<template>
	<article class="careers">
		<h1>Join Our Team</h1>
		<div class="content">
			<p>
				Thank you for your interest in Weboko. There are currently no positions available.<br/>
				Please visit our site again for future job postings that may relate to your experience and talents.
			</p>
		</div>

	</article>
</template>

<script>
	export default {
		name: 'careers',
		data () {
			return {
			}
		}
	}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// careers.vue?0d11fee0